/**
 * Structured cells reach the browser already parsed.
 *
 * The stored procedures mark them with a literal `json: ` prefix, but that
 * prefix never survives the trip: `DataService.DictionaryRowMapper` strips it
 * and deserializes the payload before the response is written
 * (`SaleIT.Common/Services/DataService.cs`). So production sends an object
 * where the SP wrote a string, and code that only knows the string form
 * silently degrades — a hierarchy cell renders as `[object Object]`.
 *
 * Both shapes are accepted: the object is what the API returns, the prefixed
 * string is what a direct `sqlcmd` call returns, which is how these columns
 * get probed by hand.
 */
export function jsonValue<T>(raw: unknown): T | null {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw as T;
  if (typeof raw !== 'string') return null;

  const trimmed = raw.trim();
  const body = trimmed.toLowerCase().startsWith('json:')
    ? trimmed.slice(trimmed.indexOf(':') + 1).trim()
    : trimmed;
  if (!body.startsWith('{') && !body.startsWith('[')) return null;

  try {
    return JSON.parse(body) as T;
  } catch {
    return null;
  }
}
